<div class="downloadButton"  (click)="exportToCsv()">
    <mat-icon>cloud_download</mat-icon>
</div>